import React from "react"
import PropTypes from "prop-types"
import { Box, Typography, makeStyles } from "@material-ui/core"

import Image from "./image"

const useStyles = makeStyles(theme => ({
  heading: {
    marginBottom: theme.spacing(1.25),
  },
}))

const ServiceItem = props => {
  const classes = useStyles()
  const { imgName, alt, title, description, ...rest } = props

  return (
    <Box width="200px" height="75x" {...rest}>
      <Box mb="18px">
        <Image imgName={imgName} alt={alt} />
      </Box>
      <Box textAlign="center">
        <Typography className={classes.heading} variant="h3">
          {title}
        </Typography>
        <Typography>{description}</Typography>
      </Box>
    </Box>
  )
}

ServiceItem.propTypes = {
  imgName: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}

export default ServiceItem
